module.exports = __webpack_public_path__ + "img/au-nsw.67c52031.svg";